import { Link } from 'react-router-dom';

const ServicesSection: React.FC = () => {
  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className="py-12 sm:py-16 lg:py-20 bg-white px-4">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8 sm:mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 sm:mb-4">
            Our Services
          </h2>
          <p className="text-base sm:text-lg lg:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Comprehensive landscaping solutions tailored to your property's unique needs
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
          {/* Service Card 1 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/1372d4f25c2f636f63a0df071af89e47.png" 
                alt="Mulching and Gardening Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-plant-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Mulching & Gardening</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Premium mulch installation and expert garden maintenance to keep your landscape vibrant and healthy year-round.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Service Card 2 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/275aa04d8ae8278dfcbe6fc3b084f978.jpeg" 
                alt="Lawn Mowing and Maintenance"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-scissors-cut-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Lawn Mowing & Maintenance</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Regular mowing, edging, and trimming services to maintain a pristine, professional-looking lawn every week.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Service Card 3 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/470de0ada65076638e11b672f9626c9f.jpeg" 
                alt="Window and Gutter Cleaning"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-window-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Window & Gutter Cleaning</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Thorough window washing and gutter cleaning to protect your home and enhance curb appeal with crystal-clear results.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Service Card 4 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/004c9f53daa3373fad39249e8e904d31.png" 
                alt="Plant and Tree Installation"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-seedling-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Plant & Tree Installation</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Expert selection and installation of trees, shrubs, and plants perfectly suited to Maryland's climate and your landscape design.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Service Card 5 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/369df6299047b962ad6e1c7c330f1cf8.png" 
                alt="Leaf and Snow Removal"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-snowy-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Leaf & Snow Removal</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                Seasonal cleanup services including fall leaf removal and winter snow clearing to keep your property safe and accessible.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>

          {/* Service Card 6 */}
          <div className="bg-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow border border-gray-100">
            <div className="h-48 sm:h-56 lg:h-64 w-full overflow-hidden">
              <img 
                src="https://static.readdy.ai/image/c82a80d6d696663c2db3260ddbcff61b/ed7183572657a5be75e5acd96d2db50c.png" 
                alt="Power Washing Services"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-4 sm:p-5 lg:p-6">
              <div className="w-10 h-10 sm:w-12 sm:h-12 bg-[#83B328] rounded-full flex items-center justify-center mb-3 sm:mb-4">
                <i className="ri-contrast-drop-line text-xl sm:text-2xl text-white"></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-2 sm:mb-3">Power Washing Services</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-3 sm:mb-4">
                High-pressure cleaning for driveways, patios, decks, and siding to restore surfaces and eliminate built-up dirt and stains.
              </p>
              <Link to="/services" onClick={handleLinkClick} className="text-[#83B328] hover:text-[#6d9620] font-semibold text-sm sm:text-base inline-flex items-center cursor-pointer">
                Learn More <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
